import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|Program History|Continuing Education|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.CredentialContinuingEducation,
	portal: 'SP',
};

export type SPCandidateCELocNames = `SPCandidateCEPageTitle`;

export const spCandidateCELocs: LocDefs<SPCandidateCELocNames> = {
	SPCandidateCEPageTitle: {
		defaultValue: 'Continuing Education',
		description: `Continuing Education page title.`,
		displayPath: `${pathStart}Page Title`,
		displayType: 'Title',
		legacyName:
			'Credential.ContinuingEducation/Candidates.ProgramHistory.ContinuingEducation.Title.PageTitle',
		...sharedProperties,
	},
};

export type SPCandidateCELocType = LocMap<SPCandidateCELocNames>;
